import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './LegalPages.css';

const TermsConditions = () => {
  return (
    <>
      <Navbar />
      <div className="legal-page">
        <div className="legal-container">
          <div className="legal-header">
            <h1>Terms & Conditions</h1>
            <p className="legal-updated">Last Updated: April 9, 2026</p>
          </div>

          <div className="legal-content">
            <section className="legal-section">
              <h2>1. Introduction and Acceptance</h2>
              <p>
                These Terms and Conditions ("Terms") govern the access to and use of the website, applications, software, 
                games, simulations, and all digital services offered under the brand iGamesTech, which is owned and operated 
                by iTwelveTech ("Company"). By accessing, browsing, registering, or using the Platform in any manner, the 
                user ("User" or "You") acknowledges that they have read, understood, and agreed to be bound by these Terms, 
                together with the Privacy Policy and any other policies incorporated herein by reference.
              </p>
              <p>
                These Terms constitute a legally binding agreement between the User and the Company. If the User does not 
                agree with any part of these Terms, they must immediately discontinue use of the Platform and Services.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. Statutory and Regulatory Compliance</h2>
              <p>
                These Terms are published in compliance with and shall be governed by the provisions of the Information 
                Technology Act, 2000, including the rules and regulations framed thereunder, particularly the Information 
                Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, and the Digital Personal 
                Data Protection Act, 2023. The Terms also operate in consonance with the Indian Contract Act, 1872, the 
                Copyright Act, 1957, the Trade Marks Act, 1999, and all other applicable laws, regulations, notifications, 
                and judicial precedents in force in India.
              </p>
            </section>

            <section className="legal-section">
              <h2>3. Definitions</h2>
              <div className="definition-list">
                <div className="definition-item">
                  <strong>Platform</strong>
                  <p>
                    Shall mean and include the Company's websites, mobile or desktop applications, online or offline software, 
                    games, simulations, AR/VR/MR environments, and any associated digital interfaces through which the Services 
                    are made available.
                  </p>
                </div>
                <div className="definition-item">
                  <strong>Services</strong>
                  <p>
                    Shall refer to all offerings of the Company, including but not limited to 2D and 3D game development, 
                    mobile, PC, and web-based gaming solutions, multiplayer and online game systems, virtual and augmented 
                    reality applications, industrial and medical simulations, educational and training modules, architectural 
                    visualizations, AI-driven interactive systems, and cloud-integrated deployments.
                  </p>
                </div>
                <div className="definition-item">
                  <strong>User Content</strong>
                  <p>
                    Shall include any data, text, images, audio, video, graphics, software, or other materials uploaded, 
                    transmitted, or otherwise made available by Users through the Platform.
                  </p>
                </div>
              </div>
            </section>

            <section className="legal-section">
              <h2>4. Eligibility and User Representations</h2>
              <p>
                By accessing or using the Platform, the User represents and warrants that they are at least eighteen (18) 
                years of age and are legally competent to enter into a binding contract under the laws of India. In the event 
                that a User is acting on behalf of a company, partnership, or other legal entity, such User represents and 
                warrants that they possess the requisite authority to bind such entity to these Terms.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. Nature and Scope of Services</h2>
              <p>
                iGamesTech is a technology-driven organization engaged in the conceptualization, design, development, deployment, 
                and commercialization of interactive digital experiences. The Company provides a wide spectrum of services, 
                including but not limited to the development of 2D and 3D games across mobile, personal computer, web, and 
                virtual reality environments; the creation of multiplayer and online gaming systems; the design of immersive 
                AR/VR/MR applications; and the development of simulation solutions for industries such as healthcare, education, 
                defense, manufacturing, real estate, and industrial safety.
              </p>
            </section>

            <section className="legal-section">
              <h2>6. User Conduct and Lawful Use</h2>
              <p>
                Users agree to utilize the Platform strictly for lawful and legitimate purposes. The User shall not upload, 
                post, transmit, distribute, or otherwise make available any content that is unlawful, defamatory, obscene, 
                invasive of privacy, harmful to minors, misleading, fraudulent, or infringing upon the intellectual property 
                or other rights of any third party.
              </p>
              <p>
                Activities such as hacking, cheating, reverse engineering, data scraping, impersonation, dissemination of 
                malware, or any conduct that disrupts the integrity or security of the Platform are strictly prohibited.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. User Accounts and Responsibility</h2>
              <p>
                Access to certain features of the Platform may require Users to create an account by providing accurate, 
                current, and complete information. Users are solely responsible for maintaining the confidentiality of their 
                login credentials and for all activities conducted through their accounts. The Company shall not be liable 
                for any loss or damage arising from unauthorized access resulting from the User's failure to safeguard such 
                credentials.
              </p>
            </section>

            <section className="legal-section">
              <h2>8. Intellectual Property Rights</h2>
              <p>
                All intellectual property rights in the Platform and Services, including but not limited to software code, 
                game mechanics, characters, storylines, graphics, animations, audiovisual elements, trademarks, logos, and 
                proprietary technologies, are owned exclusively by iGamesTech or its licensors. Nothing contained in these 
                Terms shall be construed as granting any right, title, or interest to the User except for a limited, 
                non-exclusive, non-transferable, and revocable licence to access and use the Platform in accordance with 
                these Terms.
              </p>
            </section>

            <section className="legal-section">
              <h2>9. Fees, Subscriptions, and Commercial Terms</h2>
              <p>
                Certain features or Services offered by the Company may be subject to payment of fees, subscription charges, 
                or licensing costs. All payments shall be made in accordance with the pricing communicated by the Company 
                and shall be exclusive of applicable taxes unless otherwise specified. Unless expressly stated otherwise or 
                required by law, all payments made to the Company are non-refundable.
              </p>
            </section>

            <section className="legal-section">
              <h2>10. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted under applicable law, iGamesTech shall not be liable for any indirect, 
                incidental, consequential, special, or punitive damages, including but not limited to loss of profits, 
                revenue, data, goodwill, or business opportunities, arising out of or in connection with the use or inability 
                to use the Platform or Services.
              </p>
            </section>

            <section className="legal-section">
              <h2>11. Indemnification</h2>
              <p>
                The User agrees to indemnify, defend, and hold harmless iGamesTech, its directors, officers, employees, 
                affiliates, and licensors from and against any and all claims, liabilities, damages, losses, or expenses, 
                including reasonable legal fees, arising out of or related to the User's breach of these Terms, violation 
                of applicable law, infringement of third-party rights, or misuse of the Platform.
              </p>
            </section>

            <section className="legal-section">
              <h2>12. Suspension and Termination</h2>
              <p>
                The Company reserves the right, at its sole discretion and without prior notice, to suspend, restrict, or 
                permanently terminate a User's access to the Platform if the User is found to be in violation of these Terms, 
                applicable laws, or if such action is necessary to protect the integrity, security, or reputation of the Platform.
              </p>
            </section>

            <section className="legal-section">
              <h2>13. Grievance Redressal Mechanism</h2>
              <p>
                In compliance with the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 
                2021, the Company shall designate a Grievance Officer to address user complaints and concerns. Users may 
                contact the Grievance Officer at:
              </p>
              <div className="contact-info">
                <p><strong>Email:</strong> info@igamestech.com</p>
                <p><strong>Address:</strong> Unit No. 1017, 10th Floor, SS Omnia, Sector 88, Gurugram</p>
              </div>
            </section>

            <section className="legal-section">
              <h2>14. Amendments</h2>
              <p>
                The Company reserves the right to amend or modify these Terms at any time by publishing the revised version 
                on the Platform. Continued use of the Services after such publication shall constitute the User's acceptance 
                of the amended Terms.
              </p>
            </section>

            <section className="legal-section">
              <h2>15. Governing Law and Jurisdiction</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of India. Subject to applicable 
                dispute resolution mechanisms, the courts at New Delhi shall have exclusive jurisdiction over all disputes 
                arising out of or in connection with these Terms or the use of the Platform.
              </p>
            </section>

            <section className="legal-section legal-footer-section">
              <p className="legal-company-info">
                <strong>Company Details:</strong><br />
                iGamesTech is a brand owned and operated by iTwelveTech<br />
                Unit No. 1017, 10th Floor, SS Omnia, Sector 88, Gurugram<br />
                Email: info@igamestech.com | Phone: +91 92113 43912
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsConditions;
